import { showToast } from "@hypexone/uicore";

type ToastAlert = {
  type: "error" | "success" | "info" | "warn";
  message: string;
};

export const oneClickAlertToToast =
  (dispatch: (action: unknown) => unknown) => (alert: ToastAlert) =>
    dispatch(showToast(alert));

export const validateOneClickStake = ({
  minStake,
  maxStake,
  oneClickBettingStakeAmount,
  langData,
  dispatch,
}: {
  minStake: number;
  maxStake: number;
  oneClickBettingStakeAmount: number;
  langData: Record<string, string> | undefined;
  dispatch: (action: unknown) => unknown;
}): boolean => {
  if (
    minStake !== 0 &&
    minStake > oneClickBettingStakeAmount
  ) {
    dispatch(
      showToast({
        type: "error",
        message: `${
          langData?.["minimum_stake_txt"] ?? "Minimum bet is"
        } ${minStake}. Please update your one-click stake and try again.`,
      })
    );
    return false;
  }

  if (
    maxStake !== 0 &&
    maxStake < oneClickBettingStakeAmount
  ) {
    dispatch(
      showToast({
        type: "error",
        message: `${
          langData?.["maximum_stake_txt"] ?? "Maximum bet is"
        } ${maxStake}. Please update your one-click stake and try again.`,
      })
    );
    return false;
  }

  return true;
};
